export type SimilarUnitStage =
  | "contacted"
  | "reengaged"
  | "showing_booked"
  | "applied"
  | "lease_signed";

const SIMILAR_UNIT_STAGES: SimilarUnitStage[] = [
  "contacted",
  "reengaged",
  "showing_booked",
  "applied",
  "lease_signed"
];

export const SIMILAR_UNIT_STAGE_LABEL: Record<SimilarUnitStage, string> = {
  contacted: "Contacted",
  reengaged: "Re-engaged",
  showing_booked: "Showing booked",
  applied: "Applied",
  lease_signed: "Lease signed"
};

export const SIMILAR_UNIT_STAGE_FILTER_OPTIONS: {
  id: SimilarUnitStage;
  name: string;
}[] = (
  ["contacted", "reengaged", "showing_booked", "applied"] as SimilarUnitStage[]
).map((id) => ({ id, name: SIMILAR_UNIT_STAGE_LABEL[id] }));

export const SIMILAR_UNIT_STAGES_URL_PARAM = "similar_unit_stages";

export const isSimilarUnitStage = (value: unknown): value is SimilarUnitStage =>
  typeof value === "string" &&
  SIMILAR_UNIT_STAGES.includes(value as SimilarUnitStage);

// Stamped by boompay-api on every part 2 message it sends through
// communication-service (`source_label` on the message).
export const SIMILAR_UNIT_SOURCE_LABEL = "AI agent · Similar unit notification";
